import styled from 'styled-components';

const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  width: fit-content;
  margin-top: 8px;
  color: ${(props) => props.theme.COLOR_ERROR_TEXT};
  text-align: left;
`;

const NoErrorMessage = styled.div`
  height: 18px;
  margin-top: 8px;
`;

const validationErrorComponent = {
  ErrorMessage,
  NoErrorMessage,
};

export default validationErrorComponent;
